<template>
  <!-- ADVANCED SEARCH BUTTON -->
  <div class="advanced-btn-container">
    <button
      class="ecl-button ecl-button--primary advanced-btn w-md-auto "
      @click="openAdvanced()"
      title="Advanced Search"
    >
      <span v-if="parameterCount >= 1" class="badge advanced-badge">{{
        parameterCount
      }}</span> 
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        fill="currentColor"
        class="bi bi-sliders"
        viewBox="0 0 16 16"
      >
        <path
          fill-rule="evenodd"
          d="M11.5 2a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M9.05 3a2.5 2.5 0 0 1 4.9 0H16v1h-2.05a2.5 2.5 0 0 1-4.9 0H0V3zM4.5 7a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M2.05 8a2.5 2.5 0 0 1 4.9 0H16v1H6.95a2.5 2.5 0 0 1-4.9 0H0V8zm9.45 4a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3m-2.45 1a2.5 2.5 0 0 1 4.9 0H16v1h-2.05a2.5 2.5 0 0 1-4.9 0H0v-1z"
        />
      </svg>
      <!-- <span class="btn-text">Advanced Search</span> -->
    </button>
  </div>
</template>

<script>
export default {
  name: "AdvancedSearchButton",
  data() {
    return {
      parameterCount: 0,
    };
  },
  props: {
    datasetsCount: {
          type: Number,
          default: 0
      }
  },
  methods: {
    openAdvanced() {
      // Keep ALL current query parameters (don't delete them based on results count)
      let query = { ...this.$route.query };

      // Set selectedOption based on current path if not already set
      if (!query.selectedOption) {
        if (this.$route.path.includes('catalogues')) {
          query.selectedOption = 'catalogues';
        } else if (this.$route.path.includes('datasets')) {
          query.selectedOption = 'datasets';
        } else if (this.$route.path.includes('editorial')) {
          query.selectedOption = 'editorial';
        } else {
          query.selectedOption = 'all';
        }
      }

      // Always keep locale if present
      if (this.$route.query.locale) {
        query.locale = this.$route.query.locale;
      }

      // Pass current query params to AdvancedSearch route
      this.$router.push({ name: 'AdvancedSearch', query });
    },
    // Simplified method just for parameter counting
    storeURLParameters() {
      // This method is kept mainly for parameter counting functionality
      // No longer storing parameters in sessionStorage
      this.parameterCount = this.getParameterCountFromBrowserURL();
    },
getParameterCountFromBrowserURL() {
  try {
    const currentURL = window.location.href;
    const urlObj = new URL(currentURL);
    const params = new URLSearchParams(urlObj.search);

    // List of parameters to exclude
    const excludeParams = [
      "filter",
      "searchScope",
      "locale",
      "query",
      "page",
      "sort",
      "minScoring",
      "limit",
      "minDate",
      // "maxDate",
      "selectedOption",
      "dateType",
      "showSaveSearch",
      "selectedLanguage",
      "fields" // exclude fields itself, we'll count its items separately
    ];

    // Count parameters not in exclude list
    let filteredCount = Array.from(params).filter(
      ([key]) => !excludeParams.includes(key)
    ).length;

    // Count number of fields in fields param
    const fieldsParam = params.get("fields");
    if (fieldsParam) {
      // Split by comma, filter out empty strings, count
      const fieldsCount = fieldsParam.split(",").filter(f => f.trim() !== "").length;
      filteredCount += fieldsCount;
    }

    return filteredCount;
  } catch (error) {
    console.error("Error while processing the browser URL:", error);
    return 0;
  }
},
  },
  mounted() {
    this.parameterCount = this.getParameterCountFromBrowserURL();
    this.storeURLParameters();
  },
};
</script>

<style lang="scss" scoped>
// Advanced search styles
.advanced-btn {
  margin-left: 5px;
  font-weight: 400;
  height: 48px;
}

@media screen and (max-width: 767.5px) {
  .advanced-btn {
    // margin: 15px 0 0 0;
    width: 100%;
    margin-left: 0px;
  }
}

@media screen and (min-width: 767.5px) and (max-width: 1140px) {
  .btn-text {
    display: none;
  }
  .advanced-btn-container {
    min-width: 70px !important;
  }
  .advanced-btn svg {
    margin-left: 5px;
  }
}

.advanced-btn:hover {
  background-color: #3e6cd5 !important;
}

.advanced-btn svg {
  // margin-right: 5px;
  vertical-align: text-top;
}

.advanced-badge {
  position: absolute;
  background-color: #fff;
  color: #0e47cb;
  margin-top: -8px;
  margin-left: 6px;
}

.advanced-btn-container {
  position: relative;
  // min-width: 190px;
  display: flex;
//  justify-content: flex-end;
}
</style>
